import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { browserHistory as history } from 'react-router';
import moment from "moment";
import 'moment-duration-format';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { arrayIsNotEmpty, formatDate, isDefined, sortReactTable } from '../../../../utils';
import { columnsAccessors } from '../../../../constants';
import FilterIcon from '../../../../icons/FilterIcon';
import ExportIcon from '../../../../icons/ExportIcon';
import FilterIconBack from '../../../../icons/FilterIconBack';
import CloseFilterIcon from '../../../../icons/CloseFilterIcon';
import MinMaxSelectorFilter from '../../../../components/v3/CalibrationScreenV3/MinMaxSelectorFilter';

import {
    updateProps
} from '../QaDashboardScreenActions';

class AgentsAuditsSummaryTableForManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showHelpPopup: false,
            searchTeamQuery: undefined,
            selectedTeamFilter: undefined,
            showFiltersHeader: false,

            showAvgBiasFilterPopup: false,
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined,

            searchChannelOrInteractionIdQuery: undefined,

            hoveredRowId: undefined
        };

        this.onSearchTeam = this.onSearchTeam.bind(this);
        this.onSelectTeamFilter = this.onSelectTeamFilter.bind(this);
        this.onSearchByChannelOrInteractionId = this.onSearchByChannelOrInteractionId.bind(this);

        this.showHelpPopup = this.showHelpPopup.bind(this);
        this.closeHelpPopup = this.closeHelpPopup.bind(this);

        this.hideFiltersHeader = this.hideFiltersHeader.bind(this);
        this.showFiltersHeader = this.showFiltersHeader.bind(this);

        this.getTableColumns = this.getTableColumns.bind(this);

        this.getSelectedNode = this.getSelectedFilterValuesNode.bind(this);
        this.getMinMaxFiltersHeader = this.getMinMaxFiltersHeader.bind(this);

        this.showAvgBiasFilterPopup = this.showAvgBiasFilterPopup.bind(this);
        this.hideAvgBiasFilterPopup = this.hideAvgBiasFilterPopup.bind(this);
        this.hideAvgBiasFiltersHeader = this.hideAvgBiasFiltersHeader.bind(this);

        this.showAvgBiasVsLastMonthFilterPopup = this.showAvgBiasVsLastMonthFilterPopup.bind(this);
        this.hideAvgBiasVsLastMonthFilterPopup = this.hideAvgBiasVsLastMonthFilterPopup.bind(this);
        this.hideAvgBiasVsLastMonthFiltersHeader = this.hideAvgBiasVsLastMonthFiltersHeader.bind(this);

        this.setHoveredRow = this.setHoveredRow.bind(this);
        this.goToCoaching = this.goToCoaching.bind(this);
    }

    setHoveredRow(hoveredRowId) {
        this.setState({ hoveredRowId: hoveredRowId });
    }

    showHelpPopup(e) {
        this.setState({ showHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeHelpPopup() {
        this.setState({ showHelpPopup: false });
    }

    // Show hide filter functions
    showFiltersHeader() {
        this.setState({ showFiltersHeader: true });
    }

    hideFiltersHeader() {
        this.setState({
            showFiltersHeader: false,
            searchChannelOrInteractionIdQuery: undefined,
            searchTeamQuery: undefined,
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined
        });
    }
    //AvgBias
    showAvgBiasFilterPopup() {
        this.setState({
            showAvgBiasFilterPopup: true,
        });
    }

    hideAvgBiasFilterPopup(min, max) {
        this.setState({
            showAvgBiasFilterPopup: false,
            minAvgBiasFilterValue: min,
            maxAvgBiasFilterValue: max
        });
    }

    hideAvgBiasFiltersHeader() {
        this.setState({
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined
        });
    }

    //AvgBiasVsLastMonth
    showAvgBiasVsLastMonthFilterPopup() {
        this.setState({
            showAvgBiasVsLastMonthFilterPopup: true,
        });
    }

    hideAvgBiasVsLastMonthFilterPopup(min, max) {
        this.setState({
            showAvgBiasVsLastMonthFilterPopup: false,
            minAvgBiasVsLastMonthFilterValue: min,
            maxAvgBiasVsLastMonthFilterValue: max
        });
    }

    hideAvgBiasVsLastMonthFiltersHeader() {
        this.setState({
            minAvgBiasVsLastMonthFilterValue: undefined,
            maxAvgBiasVsLastMonthFilterValue: undefined
        });
    }

    ////////////////////////////////////////////////////

    onSearchTeam({ target }) {
        this.setState({ searchTeamQuery: target.value });
    }

    onSearchByChannelOrInteractionId({ target }) {
        this.setState({ searchChannelOrInteractionIdQuery: target.value });
    }

    onSelectTeamFilter({ currentTarget }) {
        const
            {
                interactionFilters,
            } = this.props;
        if (!currentTarget || !currentTarget.options || typeof currentTarget.options.selectedIndex === 'undefined'
            || !interactionFilters || !Array.isArray(interactionFilters))
            return;

        let selectedTeamFilter = interactionFilters[currentTarget.options.selectedIndex];
        this.setState({ selectedTeamFilter });
    }

    getSelectedFilterValuesNode(key, value, onClick) {
        return (
            <div className="selected-node" style={{ padding: '0 20px' }} key={key}>
                <HighlightOffIcon onClick={() => onClick(key)} style={{ margin: '0 10px 0 -5px', color: '#98DDE1' }} />
                {value}
            </div>);
    }

    getMinMaxFiltersHeader(minValue, maxValue, closeFunc) {
        let header;
        if (isDefined(maxValue) && maxValue != '' &&
            isDefined(minValue) && minValue != '') {
            header = this.getSelectedFilterValuesNode(1, `${minValue} to ${maxValue}`, closeFunc);
        }
        else if (isDefined(minValue) && minValue != '') {
            header = this.getSelectedFilterValuesNode(1, `Min: ${minValue}`, closeFunc);
        }
        else if (isDefined(maxValue) && maxValue != '') {
            header = this.getSelectedFilterValuesNode(1, `Max: ${maxValue}`, closeFunc);
        }
        return header;
    }

    getTableColumns() {
        const
            {
                selectedQaSurveyform,
            } = this.props;
        let nameHeader = 'Agent Name';
        let teamHeader = 'Team';

        if (this.state.showFiltersHeader) {
            //rfcHeader = (<div className="table-header-filter min-max-type" onClick={this.showSelectReasonsForContactPopup}>RFC</div>);;
        }

        const nameColumn = {
            Header: nameHeader,
            accessor: columnsAccessors.agentName,
        };
        const agentTeamColumn = {
            Header: teamHeader,
            accessor: 'teams',
        };

        const columns = [nameColumn, agentTeamColumn];

        const qaSurveyCountColumn = {
            Header: 'Audits Count',
            accessor: 'qaSurveyCount',
        };
        /*        columns.push(qaSurveyCountColumn);*/

        if (selectedQaSurveyform && selectedQaSurveyform.qaSectionInfos && Array.isArray(selectedQaSurveyform.qaSectionInfos)) {
            selectedQaSurveyform.qaSectionInfos.forEach(section => {
                columns.push(
                    {
                        Header: `${section.sectionName} (${section.sectionMaxScore})`,
                        accessor: `${section.sectionName}`,
                        //width: 180
                    }
                );
            });
        }

        columns.push(
            {
                //Header: 'Last Coaching Date',
                Header: 'Audits Count',
                accessor: 'qaSurveyCount'
            });

        columns.push(
            {
                Header: 'Last Coaching Session',
                accessor: 'lastCoachingSessionDateFormatted'
            });
        columns.push(
            {
                Header: 'Coach',
                accessor: 'coachingAction'
            });
        columns.push(
            {
                Header: ' ',
                accessor: columnsAccessors.k,
                width: 60
            });
        return columns;
    }

    goToCoaching(agent) {
        history.push(`/QualityAssurance/status/coach/${agent.agentId}`);
        this.props.dispatch(updateProps({ selectedAgentToCoach: agent }));
    }

    render() {
        const
            {
                interactionToShow,
                onClick,
                selectedQaSurveyform,
                onDownloadReport
            } = this.props;

        let result = {};
        result.columns = this.getTableColumns();
        const numberOfInteractionsLabel = interactionToShow ? `(${interactionToShow.length} Agents)` : '';

        const loading = !interactionToShow || !Array.isArray(interactionToShow) || !isDefined(selectedQaSurveyform);
        if (loading === true) {
            return (
                <div>
                    <div className="teams-table-for-manager filters-wrapper">
                        <div className="teams-table-for-manager filter-area-title-wrapper">
                            <label className="teams-table-for-manager all-teams-title">Audits Summary</label>
                            <label className="teams-table-for-manager number-of-teams-title">{numberOfInteractionsLabel}</label>
                        </div>
                        <div className="export-button" onClick={this.getAuditsReport}>
                            <div class="export-button-text">Export</div>
                            <ExportIcon />
                        </div>
                    </div>
                    <ReactTable
                        columns={result.columns}
                        defaultPageSize={10}
                        loading={loading}
                        className="-striped -highlight" />
                </div>);
        }

        result.data = interactionToShow;

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (selectedQaSurveyform && selectedQaSurveyform.qaSectionInfos && Array.isArray(selectedQaSurveyform.qaSectionInfos)) {
                    selectedQaSurveyform.qaSectionInfos.forEach(section => {
                        if (arrayIsNotEmpty(row.qaSectionScoresInfo)) {
                            const currentSection = row.qaSectionScoresInfo.find(sectionInfo => sectionInfo.sectionId === section.sectionId);
                            if (isDefined(currentSection) && isDefined(currentSection.sectionAverageScore)) {
                                row[`${section.sectionName}`] = <div>
                                    {currentSection.sectionAverageScore.toFixed(2).replace(/[.,]00$/, "")}
                                </div>;
                            }
                        }
                    });
                }

                row.lastCoachingSessionDateFormatted = '-';
                if (isDefined(row.lastCoachingSessionDate)) {
                    row.lastCoachingSessionDateFormatted = formatDate(row.lastCoachingSessionDate);
                }

                row.coachingAction = <div></div>;
                if (row.agentId === this.state.hoveredRowId) {
                    row.coachingAction = <div className="v3-button agent-view-interactions"
                        style={{ width: '100px', background: '#32A6AE', padding: '13px', justifyContent: 'center' }}
                        onClick={() => this.goToCoaching(row)}>
                        Coach
                    </div>
                }
            });
        }

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="interactions -striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        //onClick: () => {
                        //    onClick(rowInfo.original.id)
                        //},
                        onMouseEnter: () => {
                            this.setHoveredRow(rowInfo.original.agentId)
                        },
                        onMouseLeave: () => {
                            this.setHoveredRow(null)
                        },
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return (
            <div>
                <div className="teams-table-for-manager filters-wrapper">
                    <div className="teams-table-for-manager filter-area-title-wrapper">
                        <label className="teams-table-for-manager all-teams-title">Audits Summary</label>
                        <label className="teams-table-for-manager number-of-teams-title">{numberOfInteractionsLabel}</label>
                    </div>
                    <div className="export-button" onClick={() => onDownloadReport()}>
                        <div class="export-button-text">Export</div>
                        <ExportIcon />
                    </div>
                </div>
                <div style={{ position: 'relative', zIndex: 0 }}>
                    {!this.state.showFiltersHeader &&
                        <div onClick={this.showFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 2,
                            right: '0',
                            cursor: 'pointer'
                        }}>
                            <FilterIconBack />
                        </div>}
                    {!this.state.showFiltersHeader &&
                        <div onClick={this.showFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 3,
                            right: '0',
                            cursor: 'pointer'
                        }}>
                            <FilterIcon />
                        </div>}

                    {this.state.showFiltersHeader &&
                        <div onClick={this.hideFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 2,
                            right: '9px',
                            top: '9px',
                            cursor: 'pointer'
                        }}>
                            <CloseFilterIcon />
                        </div>}
                    {teamsResultTable}
                    {this.state.showAvgBiasFilterPopup &&
                        (<MinMaxSelectorFilter
                            title="AVG Bias(%)"
                            onClose={this.hideAvgBiasFilterPopup} />)}
                    {this.state.showAvgBiasVsLastMonthFilterPopup &&
                        (<MinMaxSelectorFilter
                            title="Bias vs. Last Month"
                            onClose={this.hideAvgBiasVsLastMonthFilterPopup} />)}
                </div>
            </div>);
    };
}

const select = state => ({ ...state.QaDashboardManagerScreen });
export default connect(select)(AgentsAuditsSummaryTableForManager);

